import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CopyrightIcon from '@mui/icons-material/Copyright';

const UserCreate = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUserName] = useState("");
    const [contactNumber, setContactNumber] = useState("");
    const [email, setEmail] = useState("");

    const [isSubmit, setisSubmit] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        const generatedUserName = `${firstName.toLowerCase()}_${lastName.toLowerCase()}`;
        // Limit the username to a maximum length of 15 characters
        const limitedUserName = generatedUserName.slice(0, 12);
        setUserName(limitedUserName);

    }, [firstName, lastName]);

    const clearForm = () => {
        setFirstName("");
        setLastName("");
        setUserName("");
        setContactNumber("");
        setEmail("");
    };

    const submitData = async (e) => {
        e.preventDefault();

        if (!firstName) {
            setErrorMessage('First Name is required !');
            setIsSubmit(false);
            return;
        }

        if (!lastName) {
            setErrorMessage('Last Name is required !');
            setIsSubmit(false);
            return;
        }

        if (!contactNumber) {
            setErrorMessage('Contact Number is required !');
            setIsSubmit(false);
            return;
        }

        if (!email) {
            setErrorMessage('Email is required !');
            setIsSubmit(false);
            return;
        }


        const CreateData = {
            FirstName: firstName,
            LastName: lastName,
            UserName: userName,
            Email: email,
            ContactNumber: contactNumber,
            CreatedBy: userId,
            CompanyId: companyId,
            BranchId: branchId,
            CreatedDate: new Date(),
        };

        postData('UserApi', CreateData, token)
            .then((response) => {
                console.log('User Created success:', response);
                setSuccessMessage("User Created successfully!");
                setErrorMessage("");
                clearForm();
                history.push('/UserIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('User Create error:', error);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto">
                <form onSubmit={submitData}>
                    <div className='w-full mb-2 flex'>
                        <h5 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor'>User Create</h5>
                        <Button
                            variant="contained"
                            style={{ marginLeft: '8px', backgroundColor: '#006400', color: 'white' }}
                            onClick={submitData}
                        >
                            SAVE
                        </Button>

                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/UserIndex"
                            className="linkcolor"
                            style={{ marginLeft: '8px' }}
                        >
                            BACK TO LIST
                        </Button>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}
                    <div className="watermark">
                        <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                First Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                type="text" placeholder="Enter First Name"
                                maxLength={30}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Last Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                type="text" placeholder="Enter Last Name"
                                maxLength={30}
                            />
                        </div>
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                User Name
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={userName}
                                onChange={(e) => setUserName(e.target.value)}
                                type="text" placeholder="Enter User Name"
                                readOnly
                            />
                        </div>
                    </div>

                    <div className="w-full mb-4 flex">
                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Contact Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={contactNumber}
                                onChange={(e) => setContactNumber(e.target.value)}
                                type="text" placeholder="Enter Contact Number"
                                maxLength={15}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block  tracking-wide text-black text-base font-bold mb-2" htmlFor="code">
                                Email
                                <span className="text-red-500">*</span>
                            </label>
                            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline "
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="text" placeholder="Enter Email"
                                maxLength={40}
                            />
                        </div>

                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default UserCreate;

